import { connect } from 'react-redux'
import Groups from './groups'
import { getSchoolId } from '../../../stores/me/me.selectors'
import { fetchGroups } from '../../../stores/groups/groups.actions'
import {
  getGroupsFetchingStatus,
  getGroupsArray
} from '../../../stores/groups/groups.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me }) => {
  const { pending, requestError } = getGroupsFetchingStatus(state)
  const actualGroups = getGroupsArray(state)
  const actualGroupsEmpty = !actualGroups.length
  const showContent = !pending && !requestError
  return {
    actualGroupsEmpty: showContent && actualGroupsEmpty,
    schoolId: getSchoolId(me),
    showLoadingScreen: pending,
    showGroupsTable: showContent && !actualGroupsEmpty
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onMount: () => dispatch(fetchGroups(stateProps.schoolId)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Groups)
)
